import React                                             from 'react';
import { MagicColorContainer, MagicColorContainerProps } from '@src/views/components/product/MagicColorContainer';


interface CorvalAssistantMagicContainerProps extends Omit<MagicColorContainerProps, 'colorSet'> {
    isActive?: boolean,
    animated?: boolean,
    mono?: boolean,
    dark?: boolean,
}

const CorvalAssistantMagicContainerDefaultProps = {
    isActive: true,
    animated: true,
    mono:     false,
    dark:     false,
} satisfies Partial<CorvalAssistantMagicContainerProps>;

function CorvalAssistantMagicContainer( { children, ...p }: CorvalAssistantMagicContainerProps ){

    const { dark, mono, isActive, animated, ...props } = { ...CorvalAssistantMagicContainerDefaultProps, ...p };

    const colors = {
        mono:        [
            '#ab369d',
            '#b352ee',
            '#612cbc',
            '#8523d5',
            '#b352ee',
            '#ab369d',
        ],
        monoDark:    [
            '#621A4F',
            '#822777',
            '#7a346c',
            '#5a2852',
            '#7a346c',
            '#822777',
            '#621A4F',
        ],
        rainbow:     [
            '#ee7752',
            '#e73c7e',
            '#2c82bc',
            '#23d5ab',
            '#2c82bc',
            '#e73c7e',
            '#ee7752'
        ],
        rainbowDark: [
            '#944b34',
            '#822247',
            '#153d58',
            '#116c57',
            '#153d58',
            '#822247',
            '#944b34'
        ]
    };

    let colorSet = ( mono )
                   ? ( dark ) ? colors.monoDark : colors.mono
                   : ( dark ) ? colors.rainbowDark : colors.rainbow;


    return (
        <MagicColorContainer colorSet={ colorSet } { ...props }>

            { children }

        </MagicColorContainer>
    );
}

export {
    CorvalAssistantMagicContainer,
    CorvalAssistantMagicContainerDefaultProps,
    type CorvalAssistantMagicContainerProps,
};
